export const PERMISSION_TEMPLATE = {
  Tablero: true,
  Configuraciones: {
    Servicios: true,
    Disponibilidad: true,
    Empleados: true,
    Sucursal: true,
    Tutorial: true,
  },
  Herramientas: {
    Clientes: true,
    Reservas: true,
    Balance: true,
    Calendario: true,
    HorarioNoDisponible: true,
    Cupones: true,
    Beneficios: true,
  },
};
